import { useCallback, useLayoutEffect, useRef } from 'react';

type AnyFunction = (...args: any[]) => any;

/**
 * Turn a potentially unstable callback to a stable callback,
 * so in a dependency array it doesn't cause extra renders/calls.
 */
export function useEvent<T extends AnyFunction>(callback?: T) {
  const ref = useRef<AnyFunction | undefined>(() => {
    throw new Error('Cannot call an event handler while rendering.');
  });

  useLayoutEffect(() => {
    ref.current = callback;
  });

  return useCallback<AnyFunction>((...args) => ref.current?.(...args), []) as T;
}
